import { HAS_WINDOW } from '../../constants'

export const navigateUsingWindow = (url: string) => {
  if (!HAS_WINDOW) {
    return
  }

  window.location.href = url
}
